import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from "../../../../../base/icons/icon/index.js";
import { genKey } from "../../../../../../helpers/keys.js";
import { truncate } from "../../../../../../helpers/text.js";
import * as S from "./styled.js";
export const LasNews = ({ props  })=>{
    const { config , items =[]  } = props ?? {};
    const { literals  } = config ?? {};
    const { newsTitle ='' , linkText =''  } = literals ?? {};
    return /*#__PURE__*/ _jsxs(S.LastNews, {
        "data-testid": "LastNews",
        children: [
            /*#__PURE__*/ _jsxs(S.Icon, {
                children: [
                    /*#__PURE__*/ _jsx(Icon, {
                        className: "nico-newspaper"
                    }),
                    /*#__PURE__*/ _jsx(S.TitleIcon, {
                        "data-testid": "TitleIcon",
                        children: newsTitle
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(S.SliderContent, {
                children: /*#__PURE__*/ _jsx(S.SliderNews, {
                    children: items.map(({ date , linkHref , linkTitle , text  })=>/*#__PURE__*/ _jsxs(S.Link, {
                            "data-testid": "NewsItems",
                            href: linkHref,
                            title: linkTitle,
                            target: "_blank",
                            children: [
                                /*#__PURE__*/ _jsx(S.DateNew, {
                                    children: date
                                }),
                                /*#__PURE__*/ _jsx(S.Text, {
                                    children: truncate(text, 75)
                                }),
                                /*#__PURE__*/ _jsx(S.More, {
                                    children: linkText
                                }),
                                /*#__PURE__*/ _jsx(S.Divider, {
                                    children: "|"
                                })
                            ]
                        }, genKey({
                            date,
                            linkHref,
                            linkTitle,
                            text
                        })))
                })
            })
        ]
    });
};
export default LasNews;

//# sourceMappingURL=index.js.map